<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <el-form
        ref="formValidate"
        :inline="true"
        :model="params"
        label-width="60"
      >
        <el-form-item :label="$t('common.startTime')" prop="time_start">
          <el-date-picker
            v-model="params.time_start"
            type="datetime"
            :placeholder="$t('common.startTimePla')"
            style="width: 200px"
            format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('common.endTime')" prop="time_end">
          <el-date-picker
            v-model="params.time_end"
            :placeholder="$t('common.endTimePla')"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 200px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="userName" :label="$t('loginLog.account')">
          <el-input
            type="text"
            v-model.trim="params.userName"
            :placeholder="$t('common.userNamePla')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.logType')" prop="type">
          <zk-dictionary-select
            type="LoginLogType"
            v-model="params.type"
            style
          ></zk-dictionary-select>
        </el-form-item>
        <el-button type="primary" @click="query" icon="el-icon-search">{{
          $t('common.search')
        }}</el-button>
      </el-form>
    </div>

    <div class="black_panel_cla">
      <div class="header-button-bar">
        <zk-tool-bar @remove="remove"></zk-tool-bar>
      </div>
      <zk-table
        :data="logData"
        @selection-change="selected"
        :columns="columnData"
      ></zk-table>
      <div class="pagination-margin-top">
        <el-pagination
          background
          @size-change="changePageSize"
          @current-change="changePage"
          :current-page="pager.curPage"
          :page-size="pager.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pager.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import * as loginLog from '../../../services/loginLog.js'
import { dateFormat, dateByTimestamp, isEmpty } from '../../../utils/index.js'
import { getCurrentDateStartAndEndTime } from '@/utils/utils.js'

export default {
  name: 'ZkLoginLog',
  data() {
    let tameRang = getCurrentDateStartAndEndTime()
    let params = {
      time_start: tameRang[0].getTime(),
      time_end: tameRang[1].getTime(),
      type: '',
      userName: ''
    }
    let typeList = [
      {
        value: '1',
        label: this.$t('loginLog.loginLog'),
        width: 80
      },
      {
        value: '2',
        label: this.$t('loginLog.loginFailLog')
      },
      {
        value: '3',
        label: this.$t('loginLog.exitLog')
      }
    ]
    let columnData = [
      {
        label: this.$t('common.logType'),
        prop: 'type',
        render: (h, params) => {
          return h('zk-dictionary-transform', {
            key: params.row.id,
            props: {
              value: params.row.type,
              type: 'LoginLogType'
            }
          })
        }
      },
      {
        label: this.$t('loginLog.account'),
        prop: 'userName'
      },
      {
        label: this.$t('loginLog.time'),
        prop: 'time',
        minWdth: 120,
        render: (h, params) => {
          return h('span', dateFormat(dateByTimestamp(params.row.time), null))
        }
      },
      {
        label: 'Ip',
        prop: 'ip'
      },
      {
        label: this.$t('loginLog.source'),
        prop: 'source'
      },
      {
        label: this.$t('loginLog.details'),
        prop: 'content'
      }
    ]
    let logIdList = []
    return {
      columnData,
      logData: [],
      typeList,
      modal: false,
      id: '',
      index: '',
      params,
      logIdList
    }
  },
  methods: {
    query() {
      this.pager.curPage = 1
      this.commQuery()
    },
    commQuery() {
      if (
        !isEmpty(this.params.time_start) &&
        this.params.time_start instanceof Date
      ) {
        this.params.time_start.setMilliseconds(0)
        this.params.time_start = this.params.time_start.getTime()
      }
      if (
        !isEmpty(this.params.time_end) &&
        this.params.time_end instanceof Date
      ) {
        this.params.time_end.setMilliseconds(0)
        this.params.time_end = this.params.time_end.getTime()
      }
      loginLog
        .query({
          params: this.params,
          pager: this.pager
        })
        .then(data => {
          if (data.code === '00000000') {
            this.logData = data.payload.results.results || data.payload.results
            this.pager.total =
              data.payload.results.totalRecords || data.payload.totalRecords
            this.pager.curPage =
              data.payload.results.curPage || data.payload.curPage
            this.pager.total =
              data.payload.results.totalRecords || data.payload.totalRecords
            this.pager.pageSize =
              data.payload.results.pageSize || data.payload.pageSize
          }
        })
        .catch(data => {})
    },
    changePage(current) {
      this.pager.curPage = current
      this.commQuery()
    },
    changePageSize(pageSize) {
      this.pager.pageSize = pageSize
      this.commQuery()
    },
    confirmDelete() {
      let params = {
        ids: this.logIdList
      }
      loginLog
        .remove(params)
        .then(data => {
          if (data.code === '00000000') {
            this.query()
            this.$message({
              type: 'success',
              message: this.$t('common.successDelete')
            })
          } else {
            this.$message({
              type: 'error',
              message: data.message
            })
          }
        })
        .catch(data => {
          this.$message({
            type: 'error',
            message: data.message
          })
        })
    },
    selected(selection) {
      this.logIdList = []
      if (selection.length > 0) {
        selection.forEach(item => {
          this.logIdList.push(item.id)
        })
      }
    },
    remove() {
      if (this.logIdList.length > 0) {
        this.$confirm(
          this.$t('common.confirmDeleteRecordTip'),
          this.$t('common.confirmDelete'),
          {
            confirmButtonText: this.$t('common.yes'),
            cancelButtonText: this.$t('common.cancel'),
            type: 'warning'
          }
        )
          .then(() => {
            this.confirmDelete()
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('common.cancelDelete')
            })
          })
      } else {
        this.$message({
          message: this.$t('common.select1record'),
          type: 'warning'
        })
      }
    }
  },
  mounted() {
    this.query()
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/loginLog/src/main.vue